export const touchActiveClasses =
  'active:!border-border-weak active:!bg-background-default active:!text-text-default';
